<template>
    <div class="qualityListBox">
        <div v-if="list.length">
            <QualityList
                :list="list"
                :userType="userType"
                :pageData="pageData"
            ></QualityList>
            <Pagination :pageData="pageData" @changePage="changeCurrent" v-show="pageData.total>pageData.pageSize"></Pagination>
        </div>
        <div v-else class="noContent">
            <NoContent></NoContent>
        </div>
    </div>
</template>
<script>
    import Add from '@/components/consultant/Add'
    import QualityList from '@/components/consultant/QualityList.vue'
    import Pagination from '@/components/consultant/Pagination.vue'
    import NoContent from '@/components/NoContent.vue'
    export default {
        name: "qualityListBox",
        components: {
            Add,
            QualityList,
            Pagination,
            NoContent
        },
        data() {
            return {
                userType: 2,
                studentId: sessionStorage.getItem('myStudentStudentId'),
                // list: [],
                pageData: {
                    current:1,//当前页
                    pageSize:10,//每页多少条
                    totalPage:1,//总页数
                    total:1//总条数
                },
                list: [],
            }
        },
        created() {
            this.getList(this.pageData,1);
        },
        methods: {
            changeCurrent(value) {
                let current = value;
                this.getList(this.pageData,current);
            },
            // 获取成绩列表
            getList(pageData,current){
                this.$ajax.post(this.G_acapi + this.ports.parent.student.studentMessage.quality.getComplexQualityListByParent, {
                    pageSize: pageData.pageSize,
                    pageNumber: current
                }, {
                    headers: {
                        token: window.sessionStorage.getItem('ymtxToken')
                    }
                }).then((res) => {
                    if (res.data.code == 2000) {
                        let page = res.data.data.page;
                        this.list = res.data.data.list;
                        this.pageData={
                            current:page.pageNumber,//当前页
                            pageSize:page.pageSize,//每页多少条
                            totalPage:page.count,//总页数数
                            total:page.count//总条数
                        };
                        console.log(this.list)
                    }else{

                    }
                })
            },
        }

    }
</script>

<style scoped lang="less">
.qualityListBox {
    min-height: 600px;
    padding: 0 30px;
    background-color: #fff;
    .btn {
        cursor: pointer;
    }
    .addBtn {
        height: 32px;
        margin-bottom: 20px;
        .btn {
            float: right;
            width: 150px;
            height: 32px;
            background: linear-gradient(305deg, #3d90f6 0%, #2CB2FF 100%, #2CB2FF 100%);
            border-radius: 2px;
            border: 1px solid #D9D9D9;
            font-size: 16px;
            font-weight: 500;
            color: #fff;
            line-height: 32px;
            text-align: center;
            cursor: pointer;
        }
    }
}
</style>